import { baseApi } from '@/services'
import { Declaration, PaginatedResults } from '@/types/unlock'

export const declarationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDeclarationsByProfile: builder.query<
      PaginatedResults<Declaration[]>,
      { applicationUUID: string; applicationProfileUUID: string }
    >({
      query: ({ applicationUUID, applicationProfileUUID }) =>
        `v2/applications/${applicationUUID}/application-profiles/${applicationProfileUUID}/declarations/`,
      providesTags: ['Declaration'],
    }),
  }),
})

export const { useGetDeclarationsByProfileQuery } = declarationApi
